
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AiOutlineHome } from "react-icons/ai";
import { BiCategory, BiClipboard, BiSolidOffer } from "react-icons/bi";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Collapse } from "reactstrap";
import Logo from "../../images/logo2.png";
import { MdOutlineVideoSettings, MdPhotoLibrary } from "react-icons/md";
import { VscSettings } from "react-icons/vsc";
import { BsChevronDown, BsImages } from "react-icons/bs";
import { FaUsers } from "react-icons/fa";
import { GiSpellBook } from "react-icons/gi";
import { FaMapLocationDot } from "react-icons/fa6";
import { FaRegStar } from "react-icons/fa";
import { BsTicketPerforated } from "react-icons/bs";
import { FaRegCommentDots } from "react-icons/fa";
import { FaRegQuestionCircle } from "react-icons/fa";
import { MdOutlineConfirmationNumber } from "react-icons/md";
import { MdHistory } from 'react-icons/md';
import { MdHistoryToggleOff } from "react-icons/md";
import { MdDashboard } from "react-icons/md";
import { MdConfirmationNumber } from "react-icons/md";
import { MdAccountBalanceWallet } from "react-icons/md";
import { MdGroup } from "react-icons/md";
import { MdBarChart } from "react-icons/md";
import { MdDescription } from "react-icons/md";
import { MdReplay } from "react-icons/md";
import { MdCardGiftcard } from "react-icons/md";
import { MdSupport } from "react-icons/md";
import { MdSubscriptions } from "react-icons/md";



const Sidebar = () => {

  const [performanceCollapse, setPerformanceCollapse] = useState(false);
  const performanceToggle = () => setPerformanceCollapse(!performanceCollapse);



  const { pathname } = useLocation();
  const [collapse, setCollapse] = useState(false);
  const [masterCollapse, setMasterCollapse] = useState(false);
  const [merchantCollapse, setMerchantCollapse] = useState(false);
  const [ticketInfoCollapse, setTicketInfoCollapse] = useState(false);
  const [blogCollapse, setBlogCollapse] = useState(false);
  const toggle = () => setCollapse(!collapse);
  const masterToggle = () => setMasterCollapse(!masterCollapse);
  const ticketToggle = () => setTicketInfoCollapse(!ticketInfoCollapse);
  const merchantToggle = () => setMerchantCollapse(!merchantCollapse);
  const blogToggle = () => setBlogCollapse(!blogCollapse);
  const {
    PermissionReducer: { allowedPermissions },
  } = useSelector((state) => state);
  const collapseClose = () => setCollapse(false);
  const ticketInfoCollapseClose = () => setTicketInfoCollapse(false);
  const masterCollapseClose = () => setMasterCollapse(false);
  const merchantCollapseClose = () => setMerchantCollapse(false);

  const blogCollapseClose = () => setBlogCollapse(false);
  return (
    <Wrapper>
      <div className="d-flex sidebar flex-column  flex-shrink-0 side_bg">

        <nav className="sidenav navbar-vertical navbar-expand-xs navbar-light bg-white fixed-left navbar">
          <div className="col-md-3">
            <div className="logodiv m-0">
              <Link to="/orgnizations">
                <img img className="img2" src={Logo} alt=""></img>
              </Link>
            </div>
          </div>
        </nav>
        <ul className="nav nav-pills flex-column mb-auto">
          <li className="nav-item text-white">
            <Link
              to="/orgnizations/"
              className={`nav-link py-3 ps-3 align-items-center d-flex ${pathname === "/orgnizations/" ? "link_active text-black" : "text-secondary"
                } `}
              aria-current="page"
              onClick={collapseClose}
            >
              <AiOutlineHome className="sideicon" size={22} color="black" />
              <span className="sidetext  ms-3 text-black">Home</span>
            </Link>
          </li>


          <li className="nav-item border_common ">
            <Link
              to="/orgnizations/booking-list"
              className={`nav-link py-3 ps-3 ${pathname === "/orgnizations/booking-list"
                ? "link_active text-primary"
                : "text-secondary"
                } align-items-center d-flex`}
            >
              <BiClipboard className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Booking List</span>
            </Link>
          </li>

          {/* <li className="nav-item border_common">
            <Link
              to="/ratings-reviews"
              className={`nav-link py-3 ps-3  ${pathname === "/index"
                ? "link_active text-primary"
                : "text-secondary"
                } align-items-center d-flex`}
            >
              <FaRegStar className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Ratings & Reviews</span>
            </Link>
          </li> */}
          <li className="nav-item border_common">
            <Link
              to="/orgnizations/ratings-reviews"
              className={`nav-link py-3 ps-3 d-flex align-items-center ${pathname === "/orgnizations/ratings-reviews"
                ? "  text-primary rounded"
                : "text-secondary"
                }`}
            >
              <FaRegStar className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Ratings & Reviews</span>
            </Link>
          </li>

          <li className="nav-item border_common">
            <Link
              to="/orgnizations/suggestions-feedback"
              className={`nav-link py-3 ps-3 d-flex align-items-center ${pathname === "/orgnizations/suggestions-feedback"
                ? "text-primary rounded"
                : "text-secondary"
                }`}
            >
              <FaRegCommentDots className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Suggestions & Feedback</span>
            </Link>
          </li>

          <li className="nav-item border_common">
            <Link
              to="/orgnizations/help-support"
              className={`nav-link py-3 ps-3 d-flex align-items-center ${pathname === "/orgnizations/help-support"
                ? "text-primary rounded"
                : "text-secondary"
                }`}
            >
              <FaRegQuestionCircle className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Help & Support</span>
            </Link>
          </li>

          <li className="nav-item border_common">
            <Link
              to="/orgnizations/online-tickets"
              className={`nav-link py-3 ps-3 ${pathname === "/orgnizations/online-tickets"
                ? "link_active text-primary"
                : "text-secondary"
                } align-items-center d-flex`}
            >
              <BsTicketPerforated className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Online Tickets</span>
            </Link>
          </li>

          <li className="nav-item border_common">
            <Link
              to="/orgnizations/general-tickets"
              className={`nav-link py-3 ps-3 d-flex align-items-center ${pathname === "/orgnizations/general-tickets" ? "text-primary rounded" : "text-secondary"
                }`}
            >
              <MdOutlineConfirmationNumber className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">General Tickets</span>
            </Link>
          </li>

          <li className="nav-item border_common">
            <Link
              to="/orgnizations/ticket-history"
              className={`nav-link py-3 ps-3 d-flex align-items-center ${pathname === "/orgnizations/ticket-history" ? "text-primary rounded" : "text-secondary"
                }`}
            >
              <MdHistory className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Ticket History</span>
            </Link>
          </li>

          <li className="nav-item border_common">
            <Link
              to="/orgnizations/transaction-history"
              className={`nav-link py-3 ps-3 d-flex align-items-center ${pathname === "/orgnizations/transaction-history" ? "text-primary rounded" : "text-secondary"
                }`}
            >
              <MdHistoryToggleOff className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Transaction History</span>
            </Link>
          </li>

          <li className="nav-item border_common">
            <Link
              to="/orgnizations/dashboard-super"
              className={`nav-link py-3 ps-3 d-flex align-items-center ${pathname === "/orgnizations/dashboard-super" ? "text-primary rounded" : "text-secondary"
                }`}
            >
              <MdDashboard className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Dashboard Super</span>
            </Link>
          </li>
          <li className="nav-item border_common">
            <Link
              to="/orgnizations/counter-tickets-super"
              className={`nav-link py-3 ps-3 d-flex align-items-center ${pathname === "/orgnizations/counter-tickets-super" ? "text-primary rounded" : "text-secondary"
                }`}
            >
              <MdConfirmationNumber className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Counter Tickets Super</span>
            </Link>
          </li>

          <li className="nav-item border_common">
            <Link
              to="/orgnizations/bookings-super"
              className={`nav-link py-3 ps-3 d-flex align-items-center ${pathname === "/orgnizations/bookings-super" ? "text-primary rounded" : "text-secondary"
                }`}
            >
              <MdConfirmationNumber className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Bookings Super</span>
            </Link>
          </li>

          <li className="nav-item border_common">
            <Link
              to="/orgnizations/online-tickets-super"
              className={`nav-link py-3 ps-3 d-flex align-items-center ${pathname === "/orgnizations/online-tickets-super" ? "text-primary rounded" : "text-secondary"
                }`}
            >
              <MdConfirmationNumber className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Online Tickets Super</span>
            </Link>
          </li>

          <li className="nav-item border_common">
            <Link
              to="/orgnizations/transaction-super"
              className={`nav-link py-3 ps-3 d-flex align-items-center ${pathname === "/orgnizations/transaction-super" ? "text-primary rounded" : "text-secondary"
                }`}
            >
              <MdAccountBalanceWallet className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Transaction Super</span>
            </Link>
          </li>

          <li className="nav-item border_common">
            <Link
              to="/orgnizations/partner-super"
              className={`nav-link py-3 ps-3 d-flex align-items-center ${pathname === "/orgnizations/partner-super" ? "text-primary rounded" : "text-secondary"}`}
            >
              <MdGroup className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Partner Super</span>
            </Link>
          </li>

          {/*  */}



          <li
            role="button"
            className={`border_common nav-item nav-link py-3 ps-3 align-items-center d-flex justify-content-between ${performanceCollapse ? "link_active text-primary" : "text-secondary"}`}
            onClick={performanceToggle}
          >
            <div className="d-flex align-items-center">
              <MdBarChart className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Performance & Sales</span>
            </div>
            <BsChevronDown size={18} color="black" />
          </li>

          {performanceCollapse && (
            <ul className="nav flex-column ms-4">
              <li className="nav-item">
                <Link
                  to="/orgnizations/performance/partner"
                  className={`nav-link py-2 ${pathname === "/orgnizations/performance/partner" ? "text-primary" : "text-secondary"}`}
                >
                  Partner Performance
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/orgnizations/performance/merchant"
                  className={`nav-link py-2 ${pathname === "/orgnizations/performance/merchant" ? "text-primary" : "text-secondary"}`}
                >
                  Merchant Performance
                </Link>
              </li>
            </ul>
          )}

          {/*  */}

          <li className="nav-item border_common">
            <Link
              to="/orgnizations/settlements-super"
              className={`nav-link py-3 ps-3 d-flex align-items-center ${pathname === "/orgnizations/settlements-super" ? "text-primary rounded" : "text-secondary"}`}
            >
              <MdAccountBalanceWallet className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Settlements Super</span>
            </Link>
          </li>

          <li className="nav-item border_common">
            <Link
              to="/orgnizations/invoices-super"
              className={`nav-link py-3 ps-3 d-flex align-items-center ${pathname === "/orgnizations/invoices-super" ? "text-primary rounded" : "text-secondary"
                }`}
            >
              <MdDescription className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Invoices Super</span>
            </Link>
          </li>

          <li className="nav-item border_common">
            <Link
              to="/orgnizations/subscription-super"
              className={`nav-link py-3 ps-3 d-flex align-items-center ${pathname === "/orgnizations/subscription-super" ? "text-primary rounded" : "text-secondary"
                }`}
            >
              <MdSubscriptions className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Subscription Super</span>
            </Link>
          </li>


          <li className="nav-item border_common">
            <Link
              to="/orgnizations/refunds-super"
              className={`nav-link py-3 ps-3 d-flex align-items-center ${pathname === "/orgnizations/refunds-super" ? "text-primary rounded" : "text-secondary"}`}
            >
              <MdReplay className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Refunds Super</span>
            </Link>
          </li>

          <li className="nav-item border_common">
            <Link
              to="/orgnizations/incentives-super"
              className={`nav-link py-3 ps-3 d-flex align-items-center ${pathname === "/orgnizations/incentives-super" ? "text-primary rounded" : "text-secondary"}`}
            >
              <MdCardGiftcard className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Incentives Super</span>
            </Link>
          </li>

          <li className="nav-item border_common">
            <Link
              to="/orgnizations/help-support-super"
              className={`nav-link py-3 ps-3 d-flex align-items-center ${pathname === "/orgnizations/help-support-super" ? "text-primary rounded" : "text-secondary"
                }`}
            >
              <MdSupport className="sideicon" size={22} color="black" />
              <span className="sidetext ms-3 text-black">Help & Support Super</span>
            </Link>
          </li>
        </ul>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.aside`
  .active {
    font-weight: 700;
  }
  .link_active {
    background: rgba(0, 0, 0, 0.14) !important;
  }
  .sidebar {
    width: 230px;
    background-color: transparent;
    min-height: 100vh;
    padding-top: 10px;
  }

  .side_bg {
    background: white;
  }
  .nav-pills .nav-link {
    background: none;
    border-radius: 0 !important;
  }
    a.nav-link.py-3.ps-3.d-flex.align-items-center.text-primary.rounded {
    background-color: #dbdbdb;
}
`;

export default Sidebar;
